// src/pages/Contact.js - UPPDATERAD VERSION MED i18next
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Contact.css';
import API_URL from '../config';

function Contact() {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    setError('');
    
    try {
      const response = await fetch(`${API_URL}/api/contact`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (response.ok) {
        setSubmitted(true);
        setFormData({ name: '', email: '', subject: '', message: '' });
        
        // Reset efter 5 sekunder
        setTimeout(() => {
          setSubmitted(false);
        }, 5000);
      } else {
        setError(data.message || t('contact.form.errors.somethingWrong'));
      }
    } catch (err) {
      console.error('Contact form error:', err);
      setError(t('contact.form.errors.connectionError'));
    } finally {
      setSending(false);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="contact-page">
      <div className="contact-container">
        {/* Hero Section */}
        <div className="contact-hero">
          <h1>{t('contact.hero.title')}</h1>
          <p>{t('contact.hero.subtitle')}</p>
        </div>

        {/* Two Column Layout */}
        <div className="contact-content">
          {/* Left: Contact Info */}
          <div className="contact-info">
            <div className="info-card">
              <h2>{t('contact.info.email.title')}</h2>
              <a href="mailto:support@moricome.com" className="email-link">
                support@moricome.com
              </a>
              <p className="response-time">
                {t('contact.info.email.responseTime')}
              </p>
            </div>

            <div className="info-card">
              <h2>{t('contact.info.faq.title')}</h2>
              <p>{t('contact.info.faq.description')}</p>
              <Link to="/hur#faq" className="btn-secondary">
                {t('contact.info.faq.button')}
              </Link>
            </div>

            <div className="info-card">
              <h2>{t('contact.info.documentation.title')}</h2>
              <p>{t('contact.info.documentation.description')}</p>
              <Link to="/hur" className="btn-secondary">
                {t('contact.info.documentation.button')}
              </Link>
            </div>

            <div className="info-card">
              <h2>{t('contact.info.privacy.title')}</h2>
              <p>{t('contact.info.privacy.description')}</p>
              <div style={{ display: 'flex', gap: '10px', marginTop: '10px', flexWrap: 'wrap' }}>
                <Link to="/privacy" className="btn-link">
                  {t('contact.info.privacy.privacyLink')}
                </Link>
                <Link to="/terms" className="btn-link">
                  {t('contact.info.privacy.termsLink')}
                </Link>
              </div>
            </div>
          </div>

          {/* Right: Contact Form */}
          <div className="contact-form-section">
            <h2>{t('contact.form.title')}</h2>
            
            {submitted ? (
              <div className="success-message">
                <div className="success-icon">✅</div>
                <h3>{t('contact.form.success.title')}</h3>
                <p>{t('contact.form.success.message')}</p>
                <button 
                  onClick={() => setSubmitted(false)} 
                  className="btn-secondary"
                  style={{ marginTop: '20px' }}
                >
                  {t('contact.form.success.sendAnother')}
                </button>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="contact-form">
                {error && (
                  <div className="error-message">
                    ❌ {error}
                  </div>
                )}

                <div className="form-group">
                  <label htmlFor="name">{t('contact.form.fields.name.label')}</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder={t('contact.form.fields.name.placeholder')}
                    required
                    disabled={sending}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">{t('contact.form.fields.email.label')}</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder={t('contact.form.fields.email.placeholder')}
                    required
                    disabled={sending}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="subject">{t('contact.form.fields.subject.label')}</label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    placeholder={t('contact.form.fields.subject.placeholder')}
                    required
                    disabled={sending}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="message">{t('contact.form.fields.message.label')}</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder={t('contact.form.fields.message.placeholder')}
                    rows="6"
                    required
                    disabled={sending}
                  />
                </div>

                <button 
                  type="submit" 
                  className="btn-submit"
                  disabled={sending}
                >
                  {sending ? t('contact.form.buttons.sending') : t('contact.form.buttons.submit')}
                </button>

                <p className="form-note">
                  {t('contact.form.requiredNote')}
                </p>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;